import {isNullOrUndefined} from "../../../services/Validator";

export default function LevelAMetaDataGradeNameText({name}) {
    // Used in

    // BUILD
    if(isNullOrUndefined(name))
        return null
    return (
        <span>
            {name}
        </span>
    );
}